import React from 'react';
import { MainLayout } from '@/components/MainLayout';
import { ClientPage } from '@/components/registers/Client';

export default function ClientsPage() {
  return (
    <MainLayout>
      <ClientPage />
    </MainLayout>
  );
}